import React from "react";
import logoImg from "../assets/logo.png";

/**
 * Central brand wordmark/logo component.
 * Uses the uploaded DMASKUT Consultancy logo image.
 */
const Logo = ({ size = 36, showWordmark = false, className = "" }) => {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/favicon.jpg"
        alt="DMASKUT Consultancy"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="select-none rounded"
        draggable="false"
      />
      {showWordmark && (
        <span className="font-display font-bold tracking-tight text-blue-400">
          DMASKUT
        </span>
      )}
    </div>
  );
};

export default Logo;
